import { useState } from 'react';
import { Delete, Check, X } from 'lucide-react';

const fmt = (s) => { if (!s) return '0'; const [i, d] = s.split(','); const g = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return d !== undefined ? `${g},${d}` : g; };

export function Keypad({ title, icon, color, value, onDone, onClose, unit = '₺', decimals = true }) {
  const [s, setS] = useState(() => (value === '' || value == null || Number(value) === 0) ? '' : String(value).replace('.', ','));
  const press = (k) => setS(cur => {
    if (k === 'back') return cur.slice(0, -1);
    if (k === ',') return !decimals || cur.includes(',') ? cur : (cur || '0') + ',';
    if (k === '00') return cur === '' ? '' : cur + '00';
    const [, d] = cur.split(','); if (d !== undefined && d.length >= 2) return cur;
    return cur === '0' ? k : cur + k;
  });
  const commit = () => onDone(s === '' ? '' : Number(s.replace(',', '.')));
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', decimals ? ',' : '00', '0', 'back'];
  return <div className="modal-backdrop keypad-backdrop" onClick={onClose} data-testid="keypad"><div className="keypad-sheet" onClick={e => e.stopPropagation()}>
    <div className="keypad-head"><span className="keypad-title">{icon && <i style={{ background: color }}>{icon}</i>}{title}</span><button type="button" className="icon-btn" onClick={onClose} data-testid="keypad-close"><X size={18} /></button></div>
    <div className="keypad-display" data-testid="keypad-display"><strong>{fmt(s)}</strong><em>{unit}</em></div>
    <div className="keypad-grid">{keys.map(k => <button type="button" key={k} className={`key${k === 'back' ? ' key-back' : ''}`} onClick={() => press(k)} data-testid={`key-${k}`}>{k === 'back' ? <Delete size={22} /> : k}</button>)}</div>
    <button type="button" className="primary-btn keypad-done" onClick={commit} data-testid="keypad-done"><Check size={18} /> Tamam</button>
  </div></div>;
}
